//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class PersonAccessService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[PersonAccess.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-access/create', params || { });
	};

	//GeneratorFlag:[PersonAccess.Delete]
	async delete(personId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:personId
		}
	
		return await _server.delete('/hub/person-access/delete', {'params':params})
	};

	//GeneratorFlag:[PersonAccess.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/person-access/detail', {'params':params});
	};

	//GeneratorFlag:[PersonAccess.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/person-access/update', params || { });
	};

//GeneratorFlag:[NewAction]
}